import React from 'react';

const SocialProof: React.FC = () => {
  const logos = [
    { name: 'Phoenitech Travels', image: '/clients/phoenitech.png' },
    { name: 'Phoenitech Logistics', image: '/clients/PhoenitechLogistics.png' },
    { name: 'ZIPBUS India', image: '/clients/zippbus.png' },
    { name: 'Mirabel Technologies', image: '/clients/Mirabeltechnologies.png' },
    { name: 'Mediciti Hospitals', image: '/clients/mediciti.jpg' },
  ];

  return (
    <section className="py-12 bg-white border-y border-gray-100">
      <div className="container-main">
        <div className="text-center mb-8">
          <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Trusted by Growing Fleets Across India</p>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-12 mb-10">
          {logos.map((logo, index) => (
            <div key={index} className="opacity-70 hover:opacity-100 transition-opacity cursor-pointer">
              <img
                src={logo.image}
                alt={logo.name}
                className="max-h-10 w-auto object-contain"
              />
            </div>
          ))}
        </div>
        {/* <div className="flex flex-wrap justify-center gap-6 lg:gap-10">
          {badges.map((badge, index) => (
            <div key={index} className="flex items-center gap-2">
              <badge.icon className={`w-5 h-5 ${badge.color}`} />
              <span className="text-sm font-semibold text-gray-700">{badge.text}</span>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
};

export default SocialProof;
